module.exports = "/_next/static/images/first-home_faq-desktop-b11220dd933e8bc0e913e0ccbd8021c7.svg";